module.exports = __webpack_public_path__ + "img/collection.e05b1314.jpg";